import { parseKnownClientsFromUserAgent } from '../userAgent'

/**
 * A list of known bundle identifiers of the Vast mobile clients.
 */
export const KNOWN_MOBILE_IDENTIFIERS = ['com.vast.reach']

/**
 * Parses the Vast mobile client from the user agent, if any.
 * @param {*} userAgent
 * @returns ClientIdentifier the client identifier if the user agent contains a known Vast mobile client, otherwise undefined.
 */
export const parseVastMobileClientFromUserAgent = (userAgent: string) => {
  // Return the last known client in the list
  return parseKnownClientsFromUserAgent(
    userAgent,
    KNOWN_MOBILE_IDENTIFIERS,
  ).pop()
}
